// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ReviewPassSvg from '@rsuite/icon-font/lib/flow/ReviewPass';
var ReviewPass = createSvgIcon({
  as: ReviewPassSvg,
  ariaLabel: 'review pass',
  category: 'flow',
  displayName: 'ReviewPass'
});
export default ReviewPass;